/* eslint-disable */
import apiClient from '@u/apiClient'
import FetchEventPlanningController from '@/wayfinder/actions/App/Http/Controllers/Planning/FetchEventPlanningController'
import FetchEventPlanningOfTheDayController from '@/wayfinder/actions/App/Http/Controllers/Planning/FetchEventPlanningOfTheDayController'
import FetchUnplannedEventsController from '@/wayfinder/actions/App/Http/Controllers/Agenda/FetchUnplannedEventsController'
import FetchEventActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/Planning/FetchEventActivitiesByIdController'
import AddAssignedPersonController from '@/wayfinder/actions/App/Http/Controllers/Planning/AddAssignedPersonController'
import AddAssignedPersonToMaterialResourceController from '@/wayfinder/actions/App/Http/Controllers/Planning/AddAssignedPersonToMaterialResourceController'
import CopyPeopleFromEventController from '@/wayfinder/actions/App/Http/Controllers/Planning/CopyPeopleFromEventController'
import CopyMaterialResourceFromEventController from '@/wayfinder/actions/App/Http/Controllers/Planning/CopyMaterialResourceFromEventController'
import RemoveAssignedPeopleController from '@/wayfinder/actions/App/Http/Controllers/Planning/RemoveAssignedPeopleController'
import AddAssignedMaterialResourceController from '@/wayfinder/actions/App/Http/Controllers/Planning/AddAssignedMaterialResourceController'
import GetAssignedPersonController from '@/wayfinder/actions/App/Http/Controllers/Planning/GetAssignedPersonController'
import GetAssignedAssetsController from '@/wayfinder/actions/App/Http/Controllers/Planning/GetAssignedAssetsController'
import GetAssetsForPeriodController from '@/wayfinder/actions/App/Http/Controllers/Planning/GetAssetsForPeriodController'
import { assetsForPeriodQuery } from './assetsForPeriodQuery'
import UpdateAssignedPersonController from '@/wayfinder/actions/App/Http/Controllers/Planning/UpdateAssignedPersonController'
import UpdateAssignedPeopleController from '@/wayfinder/actions/App/Http/Controllers/Planning/UpdateAssignedPeopleController'
import CopyAssignedPeopleToEventsOfDossier from '@/wayfinder/actions/App/Http/Controllers/Planning/CopyAssignedPeopleToEventsOfDossier'
import CopyMaterialResourceToEventsDossierController from '@/wayfinder/actions/App/Http/Controllers/Planning/CopyMaterialResourceToEventsDossierController'
import RemoveAssignedMaterialResourceController from '@/wayfinder/actions/App/Http/Controllers/Planning/RemoveAssignedMaterialResourceController'
import UpdateAssignedMaterialResourceController from '@/wayfinder/actions/App/Http/Controllers/Planning/UpdateAssignedMaterialResourceController'
import DeleteEventByIdController from '@/wayfinder/actions/App/Http/Controllers/Agenda/DeleteEventByIdController'

let base_error = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  fetchEvents({ commit, getters, state }, payload) {
    if (state.eventsAbortController) {
      state.eventsAbortController.abort()
    }
    const controller = new AbortController()
    commit('setEventsAbortController', controller)
    return new Promise((resolve, reject) => {
      apiClient
        .route(FetchEventPlanningController.post(), payload, {
          signal: controller.signal
        })
        .then((response) => {
          commit('setEventsAbortController', null)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  //region fetch
  async fetchEventsOfTheDay({ commit, getters }, payload) {
    await apiClient
      .route(FetchEventPlanningOfTheDayController.post(), payload)
      .then(async (response) => {
        // console.log('res', response)
        if (response.data) {
          await commit('setEvents', response.data.events)
          await commit('setPlanningMetadata', response.data.metadata)
        }
      })
      .catch(async (reason) => {
        console.error('fetchEvents', reason)
      })
  },
  async fetchUnplannedEvents({ commit, getters }) {
    await apiClient
      .route(FetchUnplannedEventsController.post())
      .then(async (response) => {
        // console.log('res', response)
        if (response.data) {
          // await commit('setEvents', response.data.events)
          await commit('setEventsUnplanned', response.data.unPlanned)
        }
      })
      .catch(async (reason) => {
        console.error('fetchEvents', reason)
      })
  },

  fetchEventActivityByEventID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchEventActivitiesByIdController.get({ event: payload.event_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  //endregion
  addAssignedPerson({ commit }, payload) {
    console.log(payload)
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddAssignedPersonController.post({ event: payload.event_id }),
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  addAssignedPersonToMaterialResource({ commit }, payload) {
    console.log('add', payload)
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddAssignedPersonToMaterialResourceController.post({
            event: payload.event_id
          }),
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  //endregion
  copyAssignedPeople({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CopyPeopleFromEventController.post({ event: payload.event_id }),
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  copyAssignedMaterialResource({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CopyMaterialResourceFromEventController.post({
            event: payload.event_id
          }),
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  removeAssignedPerson({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          RemoveAssignedPeopleController.delete({ event: payload.event_id }),
          {
            data: payload.data
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  addAssignedMaterialResource({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddAssignedMaterialResourceController.post({
            event: payload.event_id
          }),
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  getAssignedPerson({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetAssignedPersonController.get({ event: payload.event_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  getAssignedAssets({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetAssignedAssetsController.get({ event: payload.event_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  getAssetsForPeriod({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetAssetsForPeriodController.get({
            query: assetsForPeriodQuery(payload)
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  updateAssignedPerson({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateAssignedPersonController.put({
            event: payload.event_id,
            assign_user: payload.user_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  updateAssignedPeople({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateAssignedPeopleController.put({ event: payload.event_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  copyAssignedPeopleDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CopyAssignedPeopleToEventsOfDossier.post({ event: payload.event_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  copyMaterialResourceDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CopyMaterialResourceToEventsDossierController.post({
            event: payload.event_id,
            material_resource: payload.material_resource_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  removeAssignedMaterialResource({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          RemoveAssignedMaterialResourceController.delete({
            event: payload.event_id,
            material_resource: payload.material_resource_id
          }),
          {
            params: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateAssignedMaterialResource({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateAssignedMaterialResourceController.put({
            event: payload.event_id,
            material_resource: payload.material_resource_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  setDataTransferObject({ commit }, payload) {
    commit('setDataTransferObject', payload)
  },

  deleteEvent({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteEventByIdController.delete.delete({ event: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  undoDeleteEvent: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteEventByIdController.undo.get({ event: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
